// Local prod without SSO (run-prod skill). A top-level constant, so production builds drop every
// branch that reads it.
export const localProdLogin =
  import.meta.env.DEV && import.meta.env.VITE_LOCAL_PROD_LOGIN === 'true';

function required(value: string | undefined, name: string): string {
  if (value === undefined || value === '') {
    throw new Error(`Missing required environment variable: ${name}`);
  }
  return value;
}

export const env = Object.freeze({
  apiUrl: required(import.meta.env.VITE_API_URL || window.location.origin, 'VITE_API_URL'),
});
